"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelEditor = void 0;
const react_1 = __importDefault(require("react"));
const CurrentMembersStep_1 = require("./CurrentMembersStep");
const AddMembersStep_1 = require("./AddMembersStep");
function ChannelEditor() {
    const [step, setStep] = react_1.default.useState('current-members');
    return step === 'current-members'
        ? react_1.default.createElement(CurrentMembersStep_1.CurrentMembersStep, { goToAddMembersStep: () => setStep('add-members') })
        : react_1.default.createElement(AddMembersStep_1.AddMembersStep, { goBack: () => setStep('current-members') });
}
exports.ChannelEditor = ChannelEditor;
